import { fExecuteAPI } from "../../Server/Apis";
import {
  AttributesINV10REQ,
  WMSStockTransfer_getStockEnquiry_GETROW,
  getINV10RBRow,
  getINV10REQDetails,
} from "../../Server/ApiV2";
import { RoundingDigitRo, KernCAConfig } from "../../Redux/roStore";

import {
  fAlertToast,
  fcovertToNumber,
  fcheck_null_undefine_replace_empty,
  Get_TransItemStockUOM,
} from "../../Utility/Utilitys";

import { Set_HeadObject_Set } from "./SliceStockTransferRequest";

import { vRdxUserInfo, StockTransferRequestRo } from "../../Redux/roStore";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

export const ErrorMsg = {
  A_VocTyp: "",
  A_VocNo: "",
  A_PostDt: "",
  A_RefNo: "",
  A_RefDt: "",

  A_RefBy: "",
  A_RefByname: "",

  A_Rounding: "",
  A_DocStat: "",
  A_Taxable: "",
  xErrorMsg: "",

  TransferType: "",

  A_FromLocName: "",
  A_FromLoc: "",

  A_ToLoc: "",
  A_ToLocName: "",
};
export const ErrorMsgDetail = {
  B_Srno: "", // int
  B_Itmcd: "",
  B_ItmName: "",
  B_Qty: "", //Decimal
  B_Unit: "",
  B_UnitName: "",
  B_PackQty: "", //Decimal
  B_BaseQty: "", //Decimal

  Narration: "",
  B_Location: "",
};
export const vHeaderSearchInit = {
  AnyData: "",
  Name: "",
  Code: "",
};

export const sTrnTyp = "INV10R";

export const ItemSearchData = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

export const locatonSearchData = ["Any", "Code", "Name"];

export const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT", "CANCEL"];
//GCSearch

const GridDataColumnsLocationSearch = [
  { field: "id", headerName: "id", hide: true },
  { field: "UID", headerName: "Code" },
  { field: "Name1", headerName: "Name" },
];

const fKey = (event) => {
  const form = document.getElementById("Head");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fKeyContent = (event) => {
  const form = document.getElementById("Content");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fValidationHead_Client = (vRdxHead, setErrorMsg) => {
  let iRes = true;

  if (
    vRdxHead.A_VocTyp === "" ||
    vRdxHead.A_VocTyp === null ||
    vRdxHead.A_VocTyp === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_VocTyp: "VocTyp should not be empty",
    }));
    fAlertToast("FAILED", "VocTyp should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_VocNo === "" ||
    vRdxHead.A_VocNo === null ||
    vRdxHead.A_VocNo === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_VocNo: "VocNo should not be empty" }));
    fAlertToast("FAILED", "VocNo should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_RefDt === "" ||
    vRdxHead.A_RefDt === null ||
    vRdxHead.A_RefDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_RefDt: "Date should not be empty",
    }));
    fAlertToast("FAILED", "Date should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PostDt === "" ||
    vRdxHead.A_PostDt === null ||
    vRdxHead.A_PostDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PostDt: "Post should not be empty",
    }));
    fAlertToast("FAILED", "Post should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_FromLoc === "" ||
    vRdxHead.A_FromLoc === null ||
    vRdxHead.A_FromLoc === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_FromLoc: "From location should not be Empty",
    }));
    fAlertToast("FAILED", "From location should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_ToLoc === "" ||
    vRdxHead.A_ToLoc === null ||
    vRdxHead.A_ToLoc === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_ToLoc: "To location should not be Empty",
    }));
    fAlertToast("FAILED", "To location should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.TransferType === "" ||
    vRdxHead.TransferType === null ||
    vRdxHead.TransferType === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      TransferType: "Transfer Type should not be Empty",
    }));
    fAlertToast("FAILED", "Transfer Type should not be Empty");
    iRes = false;
  }

  return iRes;
};

export const UnitRateFlag = () => {
  const { DBKernObj } = KernCAConfig();
  const iShowField = DBKernObj.WMINV03_UNITRATE_VLDT?.Val === "N";
  if (iShowField) {
    return false;
  } else {
    return true;
  }
};
const fValidationDetail_Client = (
  vRdxHead,
  sBufferObj,
  setErrorMsgDetail,
  sDetailGridData
) => {
  let iRes = true;

  if (
    sBufferObj.B_Srno === "" ||
    sBufferObj.B_Srno === null ||
    sBufferObj.B_Srno === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    fAlertToast("FAILED", "Serial number should not be empty");
    iRes = false;
  }

  if (
    sBufferObj.B_Itmcd === "" ||
    sBufferObj.B_Itmcd === null ||
    sBufferObj.B_Itmcd === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    fAlertToast("FAILED", "Item code should not be empty");
    iRes = false;
  }

  if (
    sBufferObj.B_ItmName === "" ||
    sBufferObj.B_ItmName === null ||
    sBufferObj.B_ItmName === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    fAlertToast("FAILED", "Item name should not be empty");
    iRes = false;
  }

  if (
    sBufferObj.B_Qty === "" ||
    sBufferObj.B_Qty === null ||
    sBufferObj.B_Qty === undefined ||
    Number(sBufferObj.B_Qty) <= 0
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Qty should not be zero",
    }));
    fAlertToast("FAILED", "Qty should not be zero");
    iRes = false;
  }

  if (
    sBufferObj.B_Unit === "" ||
    sBufferObj.B_Unit === null ||
    sBufferObj.B_Unit === undefined
  ) {
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    fAlertToast("FAILED", "Select unit");
    iRes = false;
  } else if (
    sBufferObj.B_PackQty === "" ||
    sBufferObj.B_PackQty === null ||
    sBufferObj.B_PackQty === undefined ||
    Number(sBufferObj.B_PackQty) === 0
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    fAlertToast("FAILED", "Pack quantity should not be zero");
    iRes = false;
  }

  if (
    sBufferObj.B_Location === "" ||
    sBufferObj.B_Location === null ||
    sBufferObj.B_Location === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Location: "Detail location should not be empty",
    }));
    fAlertToast("FAILED", "Detail location should not be empty");
    iRes = false;
  }

  return iRes;
};

//GCItemSearch
const GetItemSearch = async (
  xValue,
  xVendor,
  setGridSelectRowData,
  setGridSelectRowArr
) => {
  //openCustomer to call api on open modal if value in any data

  let sItemSearch = {
    v_AnyData: xValue,
    v_ItmCd: "",
    v_ItmName: "",
    v_Barcode: "",
    v_ModelSelectedValue: "",
    v_RefNo1: "",
    v_NameFc: "",
    v_CostPr: "",
    v_RSP: "",
    v_Catalogue: "",
    v_Br: "",
    v_RefNo3: "",
    v_Loc: "",
    v_Vendor: xVendor,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(sItemSearch);
  const vItemSearch = await fExecuteAPI("GRN_ITEMSEARCH_GETROW", FinalObj);
  if (vItemSearch.Status === 200) {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setGridSelectRowArr(vItemSearchArr);
    setGridSelectRowData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.Type.response.data.message
        ? vItemSearch.Type.response.data.message
        : "Error in ItemSearch"
    );
    return [];
  }
};

//API  UNIT_RATE_GETROW
const GetUnitRateArr = async (xItmCd, xUnitId, xType, xLoc) => {
  let vUnitRateObj = {
    ItmCd: xItmCd,
    UnitId: xUnitId,
    Type: xType,
    Loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vUnitRateObj);

  const UnitRateInfo = await fExecuteAPI("WMINV10_UnitRate_GETROW", FinalObj);
  if (UnitRateInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitRateInfo.ResultSet.length > 0) {
      return UnitRateInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitRateInfo.Type.response.data.message
        ? UnitRateInfo.Type.response.data.message
        : "Error in UnitRateArr"
    );
    return [];
  }
};

//TODO FULLSEARCH ,UNITARR ,AND CALCULATION
const fItemCodeDependency = async (
  vItemSearchFull,
  vRdxWmsHead,
  sBufferObj,
  setBufferObj,
  setUnit
) => {
  if (vItemSearchFull.length > 0) {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
      B_Barcode: vItemSearchFull[0].BarCode,
      // B_TaxDept: vRdxGRNtax1arr?.UId,
      // B_TaxPerc: vRdxGRNtax1arr?.Perc,
    }));

    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    let iUnit = vItemSearchFull[0]?.DefUnit || "";

    if (!iUnit) {
      iUnit = vItemSearchFull[0]?.PurUOM || "";
    }

    let vItemUnitSet = currentUnitArr.find((obj) => {
      return obj.Unit === iUnit;
    });

    if (!vItemUnitSet) {
      iUnit = currentUnitArr[0]?.Unit || "";

      vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === iUnit;
      });
    }
    await Unit_Onchange_001(vItemUnitSet, setBufferObj, sBufferObj);

    document.getElementsByName("B_Qty")[0]?.focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

export const Unit_Onchange_001 = async (
  xUnitObj = {},
  setBufferObj,
  sBufferObj
) => {
  if (!!xUnitObj) {
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: xUnitObj.Unit,
      B_UnitName: xUnitObj.Name1,
      B_PackQty: xUnitObj.PackQty,
    }));
  }
  let { B_BaseQty } = fCal(sBufferObj.B_Qty, xUnitObj.PackQty);
  setBufferObj((obj) => ({
    ...obj,
    B_BaseQty,
  }));
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch.Type == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};

export const INV10REQ_LINE_LOCFlag = () => {
  const { DBKernObj } = KernCAConfig();
  const iShowField = DBKernObj.INV10REQ_LINE_LOC?.Val === "Y";
  if (iShowField) {
    return true;
  } else {
    return false;
  }
};

const fLoad_Grid = async (
  xB_VocNo,
  xB_Srno,
  setDetailGridData,

  xVocTyp,
  xRoundingValue
) => {
  const iSIDetail = await GetSIDetail(xB_VocNo, xB_Srno, xVocTyp);
  if (iSIDetail.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
  } else {
    setDetailGridData([]);
  }
};

//HEAD LOADING API
// Api

// Checkbox_Rights_GETROW
const GetCheckboxUserRights = async (dispatch) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const vCheckBoxRightsObj = {
    usercd: vRdxUserInfoObj.UserID,
    usergrp: vRdxUserInfoObj.UserGroupCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vCheckBoxRightsObj);
  const vCheckBoxRights = await fExecuteAPI(
    "Checkbox_User_Rights_GETROW",
    FinalObj
  );
  if (vCheckBoxRights?.Type?.toUpperCase() === "SUCCESS") {
    return vCheckBoxRights?.ResultSet;
  } else {
    fAlertToast(
      "FAILED",
      vCheckBoxRights?.response?.data?.message
        ? vCheckBoxRights?.response?.data?.message
        : "Error in CheckBoxRights"
    );
    return [];
  }
};

//API Unit GETITEMUNITSINBOUND_GETROW
const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    ItemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("WMINV10_itemUnit_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.response.data.Status
        ? UnitInfo.response.data.Status
        : "Error in UnitArr"
    );
    return [];
  }
};

//API  ITEM_LINE_GETROW
const GetItemLineArr = async (xItemCode, xLoc, xParty, setItemLine) => {
  let vItemLineObj = {
    v_ItemCd: xItemCode,
    v_Loc: xLoc,
    v_Vendor: xParty,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemLineObj);

  const ItemLineInfo = await fExecuteAPI("ITEM_LINE_GETROW", FinalObj);
  if (ItemLineInfo.Status === 200) {
    if (ItemLineInfo.ResultSet.length > 0) {
      setItemLine(ItemLineInfo.ResultSet);
      return ItemLineInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      ItemLineInfo.Type.response.data.message
        ? ItemLineInfo.Type.response.data.message
        : "Error in ItemLineArr"
    );
    return [];
  }
};

//API
const GetItemFullSearchArr = async (xItemName, xLoc) => {
  // let vItemFullSearchDataObj = {
  //   v_AnyData: xItemName,
  //   v_TransType: "F",
  //   v_Report: "Y",
  // };
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    FinalObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull.Type.response.data.message
        ? vItemSearchFull.Type.response.data.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

//API GETSIDETAILS_GETROW
const GetSIDetail = async (xB_VocNo, xB_Srno, xVocTyp) => {
  let iSIDetailObj = {
    v_B_VocTyp: !!xVocTyp ? xVocTyp : "",
    v_B_VocNo: !!xB_VocNo ? xB_VocNo : "",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const resp = await getINV10RBRow(FinalObj);

  if (resp?.status === 200) {
    if (resp.data.ResultSet?.length > 0) {
      return resp?.data?.ResultSet;
    } else {
      return [];
    }
  }
};

//API GETSIHEAD_GETROW to gethead
const fDisplay = async (xA_VocTyp, A_VocNo, dispatch, fNewDetail) => {
  const { HeadObject } = StockTransferRequestRo();
  let vSIHeadObj = {
    v_VocTyp: xA_VocTyp,
    v_VocNo: A_VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSIHeadObj);
  const resp = await getINV10REQDetails(FinalObj);
  if (resp?.status === 200) {
    dispatch(
      Set_HeadObject_Set({
        ...HeadObject,
        A_VocTyp: resp?.data?.ResultSet[0].A_VocTyp,
        A_VocTypName: resp?.data?.ResultSet[0].VocName,
        A_VocNo: resp?.data?.ResultSet[0].A_VocNo,
        A_PostDt: resp?.data?.ResultSet[0].A_PostDt,
        A_RefDt: resp?.data?.ResultSet[0].A_RefDt,

        A_Narr: resp?.data?.ResultSet[0].A_Narr,
        A_DocStat: resp?.data?.ResultSet[0].A_DocStat,
        A_FromLoc: resp?.data?.ResultSet[0].A_Loc,
        A_FromLocName: resp?.data?.ResultSet[0].LocName,
        // A_FromLocTrn: resp?.data?.ResultSet[0].A_Loc_TRN,
        A_ToLoc: resp?.data?.ResultSet[0].A_LocTo,
        A_ToLocName: resp?.data?.ResultSet[0].LocNameTo,
        TransferType: resp?.data?.ResultSet[0]?.Mode?.toUpperCase(),
      })
    );

    fNewDetail(
      resp?.data?.ResultSet[0].A_VocNo,
      resp?.data?.ResultSet[0].A_VocTyp
    );
  }
};

const Get_ToggleDropDown_Load = async (
  xData,
  xType,
  xAcTyp,
  xExact,
  dispatch
) => {
  const { HeadObject } = StockTransferRequestRo();
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: HeadObject.A_FromLoc,
    AcTyp: xAcTyp,
    Exact: xExact,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "AccountTransSearch_GETROW",
    FinalObj
  );
  if (vLandedCostDropdownSearch?.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};

//API SALESGROUP

var vheaderArrow = 0;
const fRightClick = (e) => {
  vheaderArrow !== 1 ? (vheaderArrow = vheaderArrow + 1) : (vheaderArrow = 1);

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const fLeftClick = (e) => {
  vheaderArrow !== 0 ? (vheaderArrow = vheaderArrow - 1) : (vheaderArrow = 0);
  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const GetParty = async (dispatch, xLoc) => {
  const vPartyObj = {
    Loc: xLoc,
  };
  const vParty = await fExecuteAPI("WMINV10_Party_GETROW", vPartyObj);
  if (vParty?.Type?.toUpperCase() === "SUCCESS") {
    return vParty?.ResultSet;
  } else {
    fAlertToast(
      "FAILED",
      vParty.response.data.message
        ? vParty.response.data.message
        : "Error in Party"
    );
    return [];
  }
};

//calculation
const fCal = (xQty, xPackQty) => {
  const { roundingDigit } = RoundingDigitRo();
  const B_Qty = fcovertToNumber(xQty);
  const B_PackQty = fcovertToNumber(xPackQty);

  let B_BaseQty = B_PackQty * B_Qty;

  return {
    B_BaseQty: B_BaseQty.toFixed(roundingDigit), //Decimal
  };
};

export const GetAttributes = async (
  setObjectRights,
  setUser_Doc_Arr,
  setLocationArr,
  setDocLoading,
  setTransferType,
  // setTax,
  setFromLocation,
  setToLocation,
  setDetailLocation
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    userCd: vRdxUserInfoObj.UserID,
    userGrp: vRdxUserInfoObj.UserGroupCode,
  };
  const iAttributes = await AttributesINV10REQ(vObj);
  if (iAttributes?.status === 200) {
    setUser_Doc_Arr(iAttributes?.data?.ResultSet?.UserDoc);
    setObjectRights(iAttributes?.data?.ResultSet?.Rights);
    setDocLoading(iAttributes?.data?.ResultSet?.Voucher);
    setTransferType(iAttributes?.data?.ResultSet?.Type);
    // setTax(iAttributes?.data?.ResultSet?.TaxType);
    setLocationArr(iAttributes?.data?.ResultSet?.Location);
    setFromLocation(iAttributes?.data?.ResultSet?.FromLoc);
    setToLocation(iAttributes?.data?.ResultSet?.ToLoc);
    setDetailLocation(iAttributes?.data?.ResultSet?.DetailLocation);
    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};
export const GetHeadGrid = async (
  setHeadGridRow,
  setHeadGridShow,
  itemcode = ""
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = StockTransferRequestRo();
  var vObj = {
    itmCd: itemcode,
    userCd: vRdxUserInfoObj.UserID,
    loc: HeadObject.A_FromLoc,
  };
  const iAttributes = await WMSStockTransfer_getStockEnquiry_GETROW(vObj);
  if (iAttributes?.status === 200 && iAttributes?.data?.ResultSet.length > 0) {
    setHeadGridRow(iAttributes?.data?.ResultSet);
    setHeadGridShow(true);
  } else {
    return [];
  }
};
export const getTransItemStockUOM = async (
  setTransItemStockObj,
  xB_Itmcd,
  xB_Unit,
  xLoc
) => {
  let ApiObj = await Get_TransItemStockUOM(xB_Itmcd, xB_Unit, xLoc);
  if (ApiObj?.length > 0) {
    setTransItemStockObj({
      RPStock: ApiObj[0]?.RPStock,
      MSP: ApiObj[0].MSP,
      CostPr: ApiObj[0].CostPr,
      LPRate: ApiObj[0].LPRate,
    });
  }
};

export {
  fRightClick,
  fLeftClick,
  fKey,
  fKeyContent,
  GridDataColumnsLocationSearch,
  // Api
  GetCheckboxUserRights,
  GetUnitArr,
  GetItemLineArr,
  GetItemFullSearchArr,
  GetItemSearch,
  fItemCodeDependency,
  GetSearchItem,
  GetUnitRateArr,
  //save
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fDisplay,

  //reverse
  //Head functions
  GetParty,

  //src doc
  Get_ToggleDropDown_Load,
  fCal,

  //Approve
};
